import { SalesChannelAdd } from '#app/routes/mocra+/_form+/components/sales-channels/add.tsx'
import { SalesChannelCard } from '#app/routes/mocra+/_form+/components/sales-channels/card.tsx'
import { type SalesChannelDraft } from '#app/routes/mocra+/_form+/components/sales-channels/types.ts'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type SalesChannelListItem = {
	readonly draft: SalesChannelDraft
	readonly errors: readonly string[]
}

type Props = {
	readonly resources: SectionResources
	readonly channels: ReadonlyArray<SalesChannelListItem>
	readonly onAdd: (draft: SalesChannelDraft) => void
	readonly onEdit: (index: number) => void
	readonly onRemove: (index: number) => void
}

export function SalesChannelsSection({
	resources,
	channels,
	onAdd,
	onEdit,
	onRemove,
}: Props) {
	return (
		<Section
			title="Sales channels"
			description="Catalog the outlets you would notify—DTC, marketplaces, and retail partners."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
		>
			<div className="space-y-3">
				{channels.length > 0 ? (
					channels.map((channel, index) => {
						const errors = channel.errors
						return (
							<SalesChannelCard
								key={`sales-channel-${index}`}
								channel={channel.draft}
								onEdit={() => onEdit(index)}
								onRemove={() => onRemove(index)}
								errors={errors.length > 0 ? [...errors] : undefined}
							/>
						)
					})
				) : (
					<p className="text-muted-foreground text-sm">
						Add your first channel to outline who you will notify.
					</p>
				)}
			</div>
			<SalesChannelAdd onSubmit={onAdd} />
		</Section>
	)
}
